export const CLEAR = '@@clock/CLEAR';
export const UPDATE = '@@clock/UPDATE';

export const SET_TIME_MS = '@@clock/SET_TIME_MS';
